export const DiagnosticHasFinished = Symbol('DiagnosticHasFinished');
export type DiagnosticHasFinished = typeof DiagnosticHasFinished;
